<template>
  <v-dialog v-model="dialog" persistent max-width="400">
    <v-card>
      <v-card-title class="text-h6">Session Expired</v-card-title>
      <v-card-text>You have been deactivated by the admin.</v-card-text>
      <v-card-actions class="justify-end">
        <v-btn color="primary" @click="confirmLogout">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { ref, watch, defineEmits, defineProps } from 'vue'

const props = defineProps({
  modelValue: Boolean
})

const emit = defineEmits(['update:modelValue', 'confirmLogout'])

const dialog = ref(props.modelValue)

watch(() => props.modelValue, (val) => {
  dialog.value = val
})

watch(dialog, (val) => {
  emit('update:modelValue', val)
})

function confirmLogout() {
  emit('confirmLogout')
  dialog.value = false;
}
</script>